export const PURCHASE_ORDER_PAGES = {
  NEW: "NEW",
  IN_PROGRESS: "IN_PROGRESS",
  CLOSED: "CLOSED",
};

// Statuses that are backend-derived (not raw po_status values)
export const DERIVED_STATUSES = [
  "UNSCHEDULED",
  "PARTIALLY_SCHEDULED",
  "SCHEDULED",
  "PARTIALLY_DELIVERED",
  "IN_REVIEW",
  "EXPIRED",
];

// po_status field values (actual API response values)
export const PO_STATUS_VALUES = {
  WAITING_FOR_VENDOR_APPROVAL: "WAITING_FOR_VENDOR_APPROVAL",
  COMPLETED: "COMPLETED",
};

// Mapping of UI statuses to po_status values
export const STATUS_TO_PO_STATUS_MAP = {
  "APPROVAL_PENDING": PO_STATUS_VALUES.WAITING_FOR_VENDOR_APPROVAL,
  "DELIVERED": PO_STATUS_VALUES.COMPLETED,
};

export const PURCHASE_ORDER_STATUSES = {
  APPROVAL_PENDING: "APPROVAL_PENDING",
  UNSCHEDULED: "UNSCHEDULED",
  PARTIALLY_SCHEDULED: "PARTIALLY_SCHEDULED",
  SCHEDULED: "SCHEDULED",
  PARTIALLY_DELIVERED: "PARTIALLY_DELIVERED",
  IN_REVIEW: "IN_REVIEW",
  DELIVERED: "DELIVERED",
  EXPIRED: "EXPIRED",
};

export const PURCHASE_ORDER_PAGE_CONFIG = [
  {
    key: PURCHASE_ORDER_PAGES.NEW,
    label: "New POs",
    emptyMessage: "There are no new purchase orders waiting for your approval.",
    emptyStateDestination: PURCHASE_ORDER_PAGES.IN_PROGRESS,
    statuses: [PURCHASE_ORDER_STATUSES.APPROVAL_PENDING],
  },
  {
    key: PURCHASE_ORDER_PAGES.IN_PROGRESS,
    label: "In progress",
    emptyMessage: "There are no purchase orders in progress.",
    statuses: [
      PURCHASE_ORDER_STATUSES.UNSCHEDULED,
      PURCHASE_ORDER_STATUSES.PARTIALLY_SCHEDULED,
      PURCHASE_ORDER_STATUSES.SCHEDULED,
      PURCHASE_ORDER_STATUSES.PARTIALLY_DELIVERED,
      PURCHASE_ORDER_STATUSES.IN_REVIEW,
    ],
  },
  {
    key: PURCHASE_ORDER_PAGES.CLOSED,
    label: "Closed",
    emptyMessage: "There are no closed purchase orders.",
    statuses: [
      PURCHASE_ORDER_STATUSES.DELIVERED,
      PURCHASE_ORDER_STATUSES.EXPIRED,
    ],
  },
];

export const getPurchaseOrderPageConfig = (page) =>
  PURCHASE_ORDER_PAGE_CONFIG.find((config) => config.key === page);

export const PURCHASE_ORDER_STATUS_CONFIG = {
  [PURCHASE_ORDER_STATUSES.APPROVAL_PENDING]: {
    label: "Approval pending",
    color: "orange",
    emptyMessage: "No POs are waiting for approval right now.",
  },
  WAITING_FOR_VENDOR_APPROVAL: {
    label: "Approval pending",
    color: "orange",
    emptyMessage: "No POs are waiting for approval right now.",
  },
  COMPLETED: {
    label: "Delivered",
    color: "green",
    emptyMessage: "No delivered POs are available right now.",
  },
  [PURCHASE_ORDER_STATUSES.UNSCHEDULED]: {
    label: "Unscheduled",
    emptyMessage: "No POs are waiting to be scheduled right now.",
  },
  [PURCHASE_ORDER_STATUSES.PARTIALLY_SCHEDULED]: {
    label: "Partially scheduled",
    emptyMessage: "No POs are partially scheduled right now.",
  },
  [PURCHASE_ORDER_STATUSES.SCHEDULED]: {
    label: "Scheduled",
    emptyMessage: "No POs are scheduled right now.",
  },
  [PURCHASE_ORDER_STATUSES.PARTIALLY_DELIVERED]: {
    label: "Partially delivered",
    emptyMessage: "No POs are partially delivered right now.",
  },
  [PURCHASE_ORDER_STATUSES.IN_REVIEW]: {
    label: "In review",
    emptyMessage: "No POs are under review right now.",
  },
  [PURCHASE_ORDER_STATUSES.DELIVERED]: {
    label: "Delivered",
    color: "green",
    emptyMessage: "No delivered POs are available right now.",
  },
  [PURCHASE_ORDER_STATUSES.EXPIRED]: {
    label: "Expired",
    emptyMessage: "No expired POs are available right now.",
  },
};

export const getPurchaseOrderStatusConfig = (status) =>
  PURCHASE_ORDER_STATUS_CONFIG[status] || {
    label: status || "Unknown",
    emptyMessage: "There are no POs in this view right now.",
  };

export const getPurchaseOrderStatusImage = (status) =>
  PURCHASE_ORDER_STATUS_CONFIG[status]
    ? `/logos/${status.toLowerCase()}.png`
    : "";

export const getPurchaseOrderEmptyStateDestination = (activePage, pageCounts) => {
  const activePageConfig = getPurchaseOrderPageConfig(activePage);
  const destinationPage = getPurchaseOrderPageConfig(activePageConfig?.emptyStateDestination);

  if (!destinationPage || Number(pageCounts[destinationPage.key] || 0) === 0) {
    return undefined;
  }

  return destinationPage;
};
